import { Api_routes, server_url } from '../config/API_Routes';
import { getRequest, postRequest } from '../config/axios-config';

const getNotifications = (params = {}) => {
  return new Promise(async (resolve, reject) => {
    try {
      const queryParams = new URLSearchParams();

      // Add any passed parameters to the query
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          queryParams.append(key, value.toString());
        }
      });
      // Construct the URL with query parameters
      const url = `${server_url}${import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT}${
        Api_routes.getNotifications
      }?${queryParams.toString()}`;

      const response = await getRequest(url);
      resolve(response);
    } catch (err) {
      console.error('Notifications fetch error:', err);
      reject(err);
    }
  });
};

const updateSeenStatus = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.updateSeenStatus,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

export { getNotifications, updateSeenStatus };
